import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Button from "./utilities/Button";
import ErrorBoundary from "./ErrorBoundary";
import ContentLoader from "react-content-loader";
import moment from "moment-timezone";
import checked from "../img/checked.svg";

const LOCALES = {
  fr: {
    title: "Annuler un rendez-vous",
    sure: "Etes-vous sûr?",
    confirm: "Confirmer",
    at: "à",
    question: "Etes-vous sûr de vouloir annuler votre rendez-vous du {{date}}?",
    error: "Erreur",
    errorText: "Nous n'avons pas trouvé ce rendez-vous...",
    bigError: "Quelque chose a mal tourné..."
  },
  de: {
    title: "Termin stornieren",
    sure: "Sind Sie sicher?",
    confirm: "Bestätigen",
    at: "um",
    question:
      "Sind Sie sicher, dass Sie Ihren Termin vom {{date}} stornieren möchten?",
    error: "Fehler",
    errorText: "Wir haben diesen Termin nicht gefunden...",
    bigError: "Etwas is schief gegangen..."
  },
  lu: {
    title: "Rendez-vous annuléieren",
    sure: "Sidd dir sécher?",
    confirm: "Bestätegen",
    at: "um",
    question:
      "Sidd dir sécher, dat dir den Rendez-vous vum {{date}} annuléieren wëllt?",
    error: "Feeler",
    errorText: "Mir hunn dësen Rendez-vous net fonnt",
    bigError: "Iergendeppes ass schif gaangen..."
  }
};

class CancelRdv extends React.Component {
  state = {
    hash: "",
    loading: false,
    deleted: false,
    error: false
  };

  sendAlertEmail = () => {
    let email = this.props.getSlotById.Slot.doctor.email;

    let patientPrenom = this.props.getSlotById.Slot.patient.prenom
      ? this.props.getSlotById.Slot.patient.prenom
      : "";
    let patientNom = this.props.getSlotById.Slot.patient.nom
      ? this.props.getSlotById.Slot.patient.nom
      : "";
    let patientMatricule = this.props.getSlotById.Slot.patient.matricule
      ? this.props.getSlotById.Slot.patient.matricule
      : "";
    let date = moment(this.props.getSlotById.Slot.startTime).format(
      "HH:mm DD/MM/YYYY"
    );
    let when = moment().format("HH:mm DD/MM/YYYY");

    this.props
      .sendAlertEmail({
        variables: {
          email,
          date,
          when,
          patientPrenom,
          patientNom,
          patientMatricule
        }
      })
      .then(data => {
        //  this.setState({ loading: false, emailSent: true });
      })
      .catch(e => {
        console.error("error sending email to " + email, e);
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    const id = this.props.getSlotById.Slot.id;
    this.setState({ loading: true });
    let canceledBy = "Patient";
    let status = "REMOVED";
    this.props
      .updateSlotCancel({
        variables: { id, status, canceledBy }
      })
      .then(() => {
        this.setState({ loading: false, deleted: true });
        const now = moment();
        const delay = this.props.getSlotById.Slot.doctor.options
          .cancellationDelay;
        const dateWithDelay = moment(
          this.props.getSlotById.Slot.startTime
        ).subtract(delay, "hours");
        if (now.isAfter(dateWithDelay, "minutes")) {
          //alert doctor
          this.sendAlertEmail();
        }
      })
      .catch(e => {
        this.setState({ loading: false, error: true });
        console.error("delete slot", e);
      });
    /*this.props
      .deleteSlotMutation({
        variables: { id }
      })
      .then(() => {
        this.setState({ loading: false, deleted: true });
      })
      .catch(e => {
        this.setState({ loading: false, error: true });
        console.error("delete slot", e);
      });*/
  };

  render() {
    if (this.props.getSlotById.loading) {
      return (
        <section className="hero is-fullheight radial-background">
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="is-size-3">
                {LOCALES[this.props.match.params.lang].title}
              </h1>
              <br />
              <div className="columns  is-centered">
                <div className="column is-4">
                  <div className="card">
                    <div className="card-content  has-text-left">
                      <ContentLoader type="facebook" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
    const slot = this.props.getSlotById.Slot;
    if (slot === null) {
      return (
        <ErrorBoundary>
          <section className="hero is-fullheight radial-background">
            <div className="hero-body">
              <div className="container has-text-centered">
                <h1 className="is-size-3">
                  {LOCALES[this.props.match.params.lang].title}
                </h1>
                <br />
                <div className="columns  is-centered">
                  <div className="column is-4">
                    <div className="card">
                      <header className="card-header">
                        <h1 className="card-header-title has-text-centered is-size-3">
                          {LOCALES[this.props.match.params.lang].error}
                        </h1>
                      </header>
                      <div className="card-content  has-text-left">
                        <form onSubmit={this.handleSubmit}>
                          <p>
                            {LOCALES[this.props.match.params.lang].errorText}
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ErrorBoundary>
      );
    } else {
      const time = moment(slot.startTime).format(
        `DD/MM/YYYY [${LOCALES[this.props.match.params.lang].at}] HH:mm`
      );
      return (
        <ErrorBoundary>
          <section className="hero is-fullheight radial-background">
            <div className="hero-body">
              <div className="container has-text-centered">
                <h1 className="is-size-3">
                  {LOCALES[this.props.match.params.lang].title}
                </h1>
                <br />
                <div className="columns  is-centered">
                  <div className="column is-4">
                    <div className="card">
                      <header className="card-header">
                        <h1 className="card-header-title has-text-centered is-size-3">
                          {LOCALES[this.props.match.params.lang].sure}
                        </h1>
                      </header>
                      <div className="card-content  has-text-left">
                        <form onSubmit={this.handleSubmit}>
                          <p>
                            {LOCALES[
                              this.props.match.params.lang
                            ].question.replace("{{date}}", time)}
                          </p>
                          <br />
                          <div className="field  has-text-centered">
                            {!this.state.deleted &&
                            slot.status !== "REMOVED" ? (
                              <Button
                                text={
                                  LOCALES[this.props.match.params.lang].confirm
                                }
                                type="submit"
                                disabled={this.state.loading}
                              />
                            ) : (
                              <figure className="image is-32x32">
                                <img alt="checke" src={checked} />
                              </figure>
                            )}
                            {this.state.error ? (
                              <p className="has-text-danger">
                                {LOCALES[this.props.match.params.lang].bigError}
                              </p>
                            ) : null}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ErrorBoundary>
      );
    }
  }
}

const SLOT_BY_ID = gql`
  query SlotById($cancelationHash: String) {
    Slot(cancelationHash: $cancelationHash) {
      id
      startTime
      status
      patient {
        id
        nom
        prenom
        matricule
      }
      doctor {
        id
        email
        options {
          cancellationDelay
        }
      }
    }
  }
`;

const UPDATE_SLOT_CANCEL = gql`
  mutation updateSlotCancel(
    $id: ID!
    $status: SlotStatus!
    $canceledBy: String!
  ) {
    updateSlot(id: $id, status: $status, canceledBy: $canceledBy) {
      id
    }
  }
`;
const DELETE_RDV_MUTATION = gql`
  mutation deleteSlotMutation($id: ID!) {
    deleteSlot(id: $id) {
      id
    }
  }
`;
const SEND_ALERT_EMAIL = gql`
  mutation SendAlertEmailMutation(
    $email: String!
    $date: String!
    $patientNom: String
    $patientPrenom: String
    $patientMatricule: String
    $when: String!
  ) {
    sendAlertEmail(
      email: $email
      date: $date
      when: $when
      patientNom: $patientNom
      patientPrenom: $patientPrenom
      patientMatricule: $patientMatricule
    ) {
      success
    }
  }
`;

export default compose(
  graphql(SLOT_BY_ID, {
    name: "getSlotById",
    options: props => ({
      variables: {
        cancelationHash: props.match.params.cancelationHash
      }
    })
  }),
  graphql(SEND_ALERT_EMAIL, {
    name: "sendAlertEmail"
  }),
  graphql(DELETE_RDV_MUTATION, {
    name: "deleteSlotMutation"
  }),
  graphql(UPDATE_SLOT_CANCEL, {
    name: "updateSlotCancel"
  })
)(withRouter(CancelRdv));



// WEBPACK FOOTER //
// ./src/components/Cancel.js